module.exports = __webpack_public_path__ + "fonts/a1acb00.ttf";